// import qs from 'qs';
import defaultApi from '@/utils/request';

export default {
  Load(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_langVeriLimit/Load',
      params,
    });
  },
  Get(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_langVeriLimit/Get',
      params,
    });
  },
  GetByGroup(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_langVeriLimit/GetByGroup',
      params,
    });
  },
  Add(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_langVeriLimit/Add',
      data,
    });
  },
  Update(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_langVeriLimit/Update',
      data,
    });
  },
  Del(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_LangVeriLimit/Delete',
      headers: { 'Content-Type': 'application/json' },
      data,
    });
  },
};
